import IMask from '../../../../../assets/vendor/imask/dist/imask';

export default class Form{
    constructor($element) {
        this.$element = $element;
        this.$error = this.$element.querySelector('.form__error');
        this.$fields = this.$element.querySelectorAll('input:not([type="hidden"]):not([type="checkbox"]):not([type="radio"]), select, textarea');
        this.$loader = this.$element.querySelector('[data-form-loader]');

        this.$fields.forEach($field => new FormField($field));

        // if we have an error
        if (this.$error) {
            window.scrollTo(0, (this.$error.getBoundingClientRect().top + window.scrollY) - document.querySelector('[data-navigation]').getBoundingClientRect().height);
        }

        this.$element.querySelectorAll('[data-mask]').forEach(($el) => new IMask($el, {mask: $el.dataset.mask}));

        this.onSubmit = this.onSubmit.bind(this);
        this.$element.addEventListener('submit', this.onSubmit);
    }

    onSubmit(e) {
        this.$loader.classList.add('loader--loading'); 
    }
}

class FormField {
    constructor($field) {
        this.$field = $field;
        this.$label = $field.parentNode.querySelector('.form__label');

        this.fieldFocus = this.fieldFocus.bind(this);
        this.fieldBlur = this.fieldBlur.bind(this);
        this.fieldWidthValue = this.fieldWidthValue.bind(this);

        this.$field.addEventListener('focus', this.fieldFocus);
        this.$field.addEventListener('blur', this.fieldBlur);
        this.$field.addEventListener('change', this.fieldWidthValue);

        if (this.$field.getAttribute('placeholder')) {
            if(this.$label) {
                this.$label.classList.add('form__label--placeholder');
            }
            this.$field.classList.add('form__control--placeholder');
        }

        this.fieldWidthValue();
    }

    fieldFocus() {
        if(this.$label) {
            this.$label.classList.add('form__label--focused');
        }
        this.$field.classList.add('form__control--focused');
    }

    fieldBlur() {
        if(this.$label) {
            this.$label.classList.remove('form__label--focused');
        }
        this.$field.classList.remove('form__control--focused');
    }

    fieldWidthValue() {
        // If this is a select, we always need to display the label. Otherwise,
        // if the select has an empty value on top (like the typical "- Choose an
        // option -") it will render value and label overlapping
        if (this.$field.nodeName === 'SELECT') {
            this.$label.classList.add('form__label--value');
            this.$field.classList.add('form__control--value');
            return;
        }

        if(this.$field.value) {
            if(this.$label) {
                this.$label.classList.add('form__label--value');
            }
            this.$field.classList.add('form__control--value');
        } else {
            if(this.$label) {
                this.$label.classList.remove('form__label--value');
            }
            this.$field.classList.remove('form__control--value');
        }
    }
}